// extracted by mini-css-extract-plugin
module.exports = {"images":"cardByCategory_images__1tnak","cardHover":"cardByCategory_cardHover__LvsuD"};